const faqPageBuilder = () => {

    let htmlElements = {};

    const getHtmlElements = () => {
        htmlElements.anchors_section = document.querySelector('#anchors-section');
        htmlElements.inner_title = document.querySelector('.faq-search-wrap .inner-title');
        htmlElements.faq_sections = document.querySelectorAll('.search-results-group');
        htmlElements.faq_sections_back = document.querySelectorAll('.search-results-group .back-to-anchors'); 
        htmlElements.faq_sections_btns = document.querySelectorAll('.search-results-group-buttons a.button'); 
        htmlElements.faq_sections_back_top = document.querySelectorAll('.collapsible-content .back-to-top'); 
        htmlElements.tech_anchors_section = document.querySelector('#tech-section');
        htmlElements.tech_faqs = document.querySelector('#faq-list-tech');

        htmlElements.faq_search_wrap = document.querySelector('.faq-search-wrap');
        htmlElements.faq_search = document.querySelector('#faq-search');
        htmlElements.faq_search_submit = document.querySelector('.faq-search-btn');
        htmlElements.faq_search_clear = document.querySelector('.faq-search-clear');
        htmlElements.faq_search_no_results = document.querySelector('.no-results');
        htmlElements.all_faq = document.querySelectorAll('.collapsible-content__item');
        htmlElements.all_faq_node = document.createElement('div');
        htmlElements.all_faq_node.classList.add('collapsible-content','collapsible-content-custom');
    }

    const backToAnchors = () => {
        if(htmlElements.tech_faqs.querySelectorAll('.collapsible-content.active').length > 0) {
            htmlElements.tech_faqs.querySelector('.collapsible-content.active').classList.remove('active');
            pushStateFAQ(`#${htmlElements.tech_faqs.id}`);
        } else {
            htmlElements.faq_sections.forEach(faq_section => {
                faq_section.classList.remove('active');
                htmlElements.anchors_section.style.display = 'block';
            });
            pushStateFAQ('');
        }
        if(window.scrollY > 150) {
            window.scrollTo(0,0);
        }
    }

    const backToTop = () => {
        window.scrollTo(0,0);
    }

    const helpPageToggler = (event) => {
        event.preventDefault();
        htmlElements.anchors_section.style.display = 'none';
        let link = event.currentTarget.dataset.link.replace('#','');
        let inner_title = event.currentTarget.querySelector('.multicolumn-card__heading').innerText.replace(/\n/g, ' ');
        htmlElements.inner_title.innerText = inner_title;
        htmlElements.faq_sections.forEach(faq_section => {
            if(faq_section.id == link) {
                faq_section.classList.add('active');
            }
        });
        if(window.scrollY > 150) {
            window.scrollTo(0,0);
        }
        pushStateFAQ(`#${link}`);
    }

    const helpPageTechToggler = (event) => {
        event.preventDefault();
        let link = event.currentTarget.dataset.link.replace('#','');
        htmlElements.tech_faqs.querySelectorAll('.collapsible-content').forEach(faq_sub_section => {
            if(faq_sub_section.id == link) {
                faq_sub_section.classList.add('active');
            }
        });
        if(window.scrollY > 150) {
            window.scrollTo(0,0);
        }
        pushStateFAQ(`#${link}`);
    }

     const buildAllFAQsection = () => {
        htmlElements.all_faq.forEach((faq_node) => {
            let clone_faq_node = faq_node.cloneNode(true);
            htmlElements.all_faq_node.appendChild(clone_faq_node);
        });

        htmlElements.all_faq_node.classList.add('hidden');
        htmlElements.faq_search_wrap.after(htmlElements.all_faq_node);
    }


	const initCollapsibleContent = () => {
		$(".collapsible-content__toggle").unbind("click").on("click", function () {
			const parent = $(this).parent();

			if (!parent.hasClass("active")) {
				parent
					.siblings(".collapsible-content__item.active")
					.removeClass("active");
				parent.addClass("active");
				$(this)
					.closest(".collapsible-content__items")
					.find(".collapsible-content__answer")
					.stop()
					.slideUp(300);
				$(this).next().stop().slideDown(300);
			} else {
				parent
					.siblings(".collapsible-content__item.active")
					.removeClass("active");
				parent
					.closest(".collapsible-content__items")
					.find(".collapsible-content__answer")
					.stop()
					.slideUp(300);
				parent.removeClass("active");
				$(this).next().stop().slideUp(300);
			}
		});
	};

    const showFAQResults = () => {
        let finds_counter = 0;

        let keywords = htmlElements.faq_search.value.toLowerCase().replace(/[^\p{L}\p{N}\s-]/gu, '').trim().split(' ');

        htmlElements.all_faq_node.querySelectorAll('.collapsible-content__item').forEach((faq_node_item) => {
            let has_keywords = 0;
            keywords.forEach((keyword) => {
                if(keyword !== '') {
                    if(faq_node_item.querySelector('.collapsible-content__question').textContent.toLowerCase().search(keyword) >= 0 || 
                        faq_node_item.querySelector('.collapsible-content__answer-inner').textContent.toLowerCase().search(keyword) >= 0) {
                        has_keywords++;
                    }
                }
            });
            if (has_keywords == keywords.length && has_keywords > 0) {
                faq_node_item.style.display = 'block';
                finds_counter++;
            } else {
                faq_node_item.style.display = 'none';
            }
        });

        if(finds_counter == 0) {
            htmlElements.faq_search_no_results.classList.add('active');
            htmlElements.all_faq_node.classList.add('hidden');
            if(document.location.hash != '#faq-list-tech') {
                htmlElements.anchors_section.style.display = 'block';
            }
        } else {
            htmlElements.all_faq_node.classList.remove('hidden');
            htmlElements.faq_search_no_results.classList.remove('active');
            htmlElements.anchors_section.style.display = 'none';
        }
    }

    const clearFAQResults = () => {
        htmlElements.faq_search.value = '';
        htmlElements.all_faq_node.classList.add('hidden');
        htmlElements.faq_search_no_results.classList.remove('active');
        //if(document.location.hash != '#faq-list-tech') {
        if(document.location.hash == '') {
            htmlElements.anchors_section.style.display = 'block';
        }
    }

    let timerFAQ;
    let readyForClickFAQ;
    const findFAQResults = () => {
        
        if(htmlElements.faq_search.value.trim() == '') {
            clearFAQResults();
        } else {
            showFAQResults();

            clearTimeout(timerFAQ);
            readyForClickFAQ = false;
            timerFAQ = setTimeout(() => {
                readyForClickFAQ = true;
                console.log('finished typing');
                console.log(htmlElements.faq_search.value.trim());
                dataLayer.push({
                    'event': 'faq_search', 
                    'search_term': htmlElements.faq_search.value.trim()
                });	
            }, 2000);

            user_typing = true;
        }
    }

    const sendFAQTermEventMetric = (ev) => {
        if (!readyForClickFAQ) return;
        readyForClickFAQ = false;
        console.log('First click after typing');
        console.log(htmlElements.faq_search.value.trim());
        console.log(ev.currentTarget.querySelector('.collapsible-content__question').innerText);
        dataLayer.push({
            'event': 'faq_search_result_click', 
            'search_term': `${htmlElements.faq_search.value.trim()}`,
            'search_term_clicked': `${ev.currentTarget.querySelector('.collapsible-content__question').innerText}`
        });	
    }

    const assignEvents = () => {
        htmlElements.faq_search.addEventListener('keyup', findFAQResults);
        htmlElements.faq_search.addEventListener('keyup', function (event) {
            if (event.key === 'Enter' || event.keyCode === 13) {
                findFAQResults();
            }
        });
        htmlElements.faq_search_submit.addEventListener('click', findFAQResults);
        htmlElements.faq_search_clear.addEventListener('click', clearFAQResults);

        htmlElements.anchors_section.querySelectorAll('.multicolumn-card[data-link]').forEach((anchor) => {
            anchor.addEventListener('click', helpPageToggler);
        });
        htmlElements.faq_sections_back.forEach((back_button) => {
            back_button.addEventListener('click', backToAnchors);
        });
        htmlElements.faq_sections_btns.forEach((faq_sections_btn) => {
            faq_sections_btn.addEventListener('click', (event) => {
                pushStateFAQ(event.currentTarget.hash);
            });
        });
        htmlElements.tech_anchors_section.querySelectorAll('.multicolumn-card[data-link]').forEach((anchor) => {
            anchor.addEventListener('click', helpPageTechToggler);
        });
        htmlElements.faq_sections_back_top.forEach((back_top_button) => {
            back_top_button.addEventListener('click', backToTop);
        });

        htmlElements.all_faq_node.querySelectorAll('.collapsible-content__item').forEach((faq_node_item) => {
            faq_node_item.addEventListener('click', sendFAQTermEventMetric);
        });
    }

    const firstLoadHashHandler = () => {
        const entryHash = window.location.hash;
        if (entryHash != '') {
            if(htmlElements.anchors_section.querySelector(`.multicolumn-card[data-link="${entryHash}"]`)) {
                htmlElements.anchors_section.querySelector(`.multicolumn-card[data-link="${entryHash}"]`).click();
            } else if(htmlElements.tech_anchors_section.querySelector(`.multicolumn-card[data-link="${entryHash}"]`)) {
                htmlElements.anchors_section.querySelector(`.multicolumn-card[data-link="#faq-list-tech"]`).click();
                htmlElements.tech_anchors_section.querySelector(`.multicolumn-card[data-link="${entryHash}"]`).click();
            } else if(document.querySelector(`.collapsible-content${entryHash}`)) {
                let parentHash = document.querySelector(`.collapsible-content${entryHash}`).closest('.search-results-group').id;
                htmlElements.anchors_section.querySelector(`.multicolumn-card[data-link="#${parentHash}`).click();
                document.querySelector(`.search-results-group-buttons .button[href="${entryHash}"`).click();
            }
        }
    }

    const pushStateFAQ = (hash) => {
        if(hash != '') {
            history.pushState(null, '', hash);
        } else {
            history.pushState(null, '', window.location.pathname);
        }
    }

    const replaceLinkedImg = () => {
        document.querySelectorAll('.collapsible-content a').forEach(a => {
            if(a.text == '[image]') {
                a.style.display = 'none';
                let new_img = document.createElement('img');
                new_img.src = a.href;
                new_img.style['max-width'] = '300px';
                a.insertAdjacentElement('afterend', new_img);
            }
        });
    }

    getHtmlElements();
    buildAllFAQsection();
    initCollapsibleContent();
    assignEvents();
    document.querySelector('body').classList.add('faq-ready');

    firstLoadHashHandler();
    replaceLinkedImg();

    window.addEventListener('popstate', () => {
        const faqHash = window.location.hash;
       if (window.location.hash == '') {
            backToAnchors();
       }
    });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    faqPageBuilder();
  });
} else {
  faqPageBuilder();
}